import css from "styled-jsx/css";

export const componentStyles = css`
  .icons {
    display: flex;
    .icon-wrapper {
      display: flex;
      gap: 8px;
      width: 100%;
      :global(img) {
        max-height: 48px;
      }
      .icon-texts-wrapper {
        display: flex;
        flex-direction: column;
        gap: 8px;
        .title {
          :global(.monday-markup-language-component) {
            font-size: 26px;
            line-height: 26px;
            font-weight: 500;
          }
        }
        .subtitle {
          :global(.monday-markup-language-component) {
            font-size: 18px;
            line-height: 20px;
          }
        }
      }
    }
  }
`;
